import type { NodeMock, StatePreset } from "../mock-types";

export const matchCancelledMock: NodeMock = {
  label: "Match Cancelled",
  description: "Match was cancelled (timeout, disconnect, etc.)",
  state: (players) => ({
    reason: "timeout",
    cancelledAt: Date.now(),
    acknowledgedBy: [players[0]?.userId].filter(Boolean),
  }),
  config: {
    displayMessage: "Match has been cancelled.",
    showReturnButton: true,
    labels: {
      title: "Match Cancelled",
    },
  },
};

export const matchCancelledPresets: StatePreset[] = [
  {
    label: "Fresh",
    build: ({ defaultState }) => ({
      state: { ...defaultState, acknowledgedBy: [] },
    }),
  },
  {
    label: "Some Ack'd",
    build: ({ players, defaultState }) => ({
      state: {
        ...defaultState,
        acknowledgedBy: players.slice(0, Math.ceil(players.length / 2)).map((p) => p.userId),
      },
    }),
  },
  {
    label: "All Ack'd",
    build: ({ players, defaultState }) => ({
      state: { ...defaultState, acknowledgedBy: players.map((p) => p.userId) },
    }),
  },
];
